import { withVersions } from "v2/hocs/withVersions";
import withUnit from "../hocs/withUnit";
import { TransparentInputWithUnit as TransparentInputWithUnitV1 } from "./TransparentInputWithUnit/v1";
import { TransparentInput as TransparentInputV1 } from "./TransparentInputWithUnit/v1";
const TransparentInputWithUnit = withVersions({
  v1: withUnit(TransparentInputWithUnitV1),
  v2: withUnit(TransparentInputWithUnitV1),
});

const TransparentInput = withVersions({
  v1: TransparentInputV1,
  v2: TransparentInputV1,
});

export { TransparentInputWithUnit, TransparentInput };
